/**
 * Created by Kim J on 2018-01-17.
 */
var DetailSamplingNotifController = (function () {
    function DetailSamplingNotifController(topic, $scope, socket, edit, $attrs) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.edit = edit;
        this.$attrs = $attrs;
        this.comp = 'sampling_notification';
        this.visibleNotifications = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    DetailSamplingNotifController.prototype.$onInit = function () {
        if (this.$attrs.section) {
            this.comp = this.$attrs.section;
        }
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailSamplingNotifController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {},
                    id: this.topic.topic._id,
                    type: [this.comp]
                };
                updateObject.data[this.comp] = {
                    add: true,
                    data: this.topic.temp[this.comp]
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
            this.setDateFields();
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    /**
     * Function to convert the three date fields to Date objects for use with the md-datepicker
     */
    DetailSamplingNotifController.prototype.setDateFields = function () {
        var _this = this;
        var dates = ['notification_date', 'first_reminder_date', 'second_reminder_date'];
        angular.forEach(dates, function (dateField) {
            if (_this.topic.topic[_this.comp][dateField]) {
                if (!_this.topic.temp[_this.comp]) {
                    _this.topic.temp[_this.comp] = {};
                }
                _this.topic.temp[_this.comp] = new Date(_this.topic.topic[_this.comp]);
            }
        });
    };
    DetailSamplingNotifController.prototype.toggleNotifications = function () {
        this.visibleNotifications = !this.visibleNotifications;
    };
    DetailSamplingNotifController.$inject = ['topic', '$scope', 'socket', 'env', '$attrs'];
    return DetailSamplingNotifController;
}());
var DetailSamplingNotifComponent = (function () {
    function DetailSamplingNotifComponent() {
        this.templateUrl = 'detail-sampling-notification.html';
        this.controllerAs = 'vm';
        this.controller = DetailSamplingNotifController;
    }
    return DetailSamplingNotifComponent;
}());
angular
    .module('application')
    .component('detailSamplingNotification', new DetailSamplingNotifComponent());

//# sourceMappingURL=detail.sampling.notif.components.js.map
